import React, { useState } from 'react';
import BsFormSelect from '../../collection/bootstrap/BsFormSelect';
import HiddenInput from '../../collection/inputs/HiddenInput';

/**
 * Select con los posibles estados de una solicitud de validación.
 * Props:
 * - pendiente: Valor por defecto para pendiente.
 * - validado: Valor por defecto para validado.
 * - fem: Si se pasa este parámetro, se tratarán las solicitudes en femenino.
 */
export default function InputEstado(props) {
    const [pendiente, setPendiente] = useState(props.pendiente);
    const [validado, setValidado] = useState(props.validado);

    const x = props.fem ? "a" : "o";
    const estados = [
        { value: 0, label: "Mostrar todo", pendiente: null, validado: null },
        { value: 1, label: "Posibles", pendiente: null, validado: true },
        { value: 2, label: "Pendientes", pendiente: true, validado: null },
        { value: 3, label: `Revisad${x}s`, pendiente: false, validado: null },
        { value: 4, label: `Aprobad${x}s`, pendiente: false, validado: true },
        { value: 5, label: `Denegad${x}s`, pendiente: false, validado: false }
    ];

    const getEstado = (pendiente, validado) => estados.filter(e => e.pendiente == pendiente && e.validado == validado)[0].value;

    const handleEstadoChange = (element) => {
        const value = element ? element.value : null;
        const filtered = estados.filter(e => e.value == value);
        const option = filtered[0];
        setPendiente(option.pendiente);
        setValidado(option.validado);
    }

    return <>
        <HiddenInput name="pendiente" value={pendiente == null ? "" : pendiente} />
        <HiddenInput name="validado" value={validado == null ? "" : validado} />
        <BsFormSelect
            label="Estado" name="estado"
            value={getEstado(pendiente, validado)}
            options={estados} isControlled
            onChange={handleEstadoChange} />
    </>;
}
